// 快看
const list = [
  {
    id:'1',
    name: '废女妖神',
    desc: ['逆袭', '恋爱'],
    author: '闻源文化',
    url: 'https://tn1-f2.kkmh.com/image/201125/g7IIhVX4C.webp-t.w207.webp.h',
    instr: '妖尊白又灵大婚当日妖力狂化暴走，被爱人一剑穿心。白又灵含恨丹破而终。再醒来，竟然借同名白家废女身体重生。打脸渣男贱女，重走修炼巅峰，没想到再遇旧人，还成了他的徒弟。你们这些满腹仁义，道貌岸然的伪君子，都给我洗干净脖子等着！ “尤其是你，许奚渊，你也尝尝被爱人亲手了断的滋味吧！”',
    pcLink:'https://www.kuaikanmanhua.com/web/topic/7010/',
    mobileLink:'https://m.dm5.com/manhua-feinvyaoshen/'
  },
  {
    id:'2',
    name: '萌妻有点皮',
    desc: ['总裁', '恋爱'],
    author: '闻源文化',
    url: 'https://tn1-f2.kkmh.com/image/190213/HpMT0gPny.webp-t.w207.webp.h',
    pcLink:'https://www.kuaikanmanhua.com/web/topic/2215/',
    mobileLink:'https://m.dm5.com/manhua-mengqiyoudianpi/',
    instr: '一场始于真心话大冒险的乌龙邂逅？一晚醉酒误与被子缱绻缠绵的暧昧之夜？他舔了舔自己渗着血珠的唇，一脸危险; 他红着脸把头埋入她的脖颈间，轻声撒娇。谁说冤家宜解不宜结？五大帅哥组团爆笑来袭，双面总裁就是非要赖上你！ 【每周三/周六双更】'
  },
  {
    id:'3',
    name: '神武帝尊',
    desc: ['重生', '逆袭'],
    author: '闻源文化',
    url: 'https://tn1-f2.kkmh.com/image/200324/XN81lRlZv.webp-t.w207.webp.h',
    pcLink:'https://www.kuaikanmanhua.com/web/topic/6151/',
    mobileLink:'https://m.dm5.com/manhua-shenwudizun/',
    instr: '一代大能高手，遭人算计，机缘巧合之下重活于世，借助上一世的修行经验，踩天才无数，踏高手如云，神挡杀神，佛挡杀佛，强势回归诸天万界! 【每周五更新】快来找我们玩~'
  },
  {
    id:'4',
    name: '桃子味的人鱼先生',
    desc: ['恋爱', '奇幻'],
    author: '闻源文化',
    url: 'https://tn1-f2.kkmh.com/image/191023/ext1HaTeF.webp-t.w207.webp.h',
    pcLink:'https://www.kuaikanmanhua.com/web/topic/5314/',
    mobileLink:'https://m.kuaikanmanhua.com/mobile/5314/list/',
    instr: '“呵，区区人类如此狂妄，见到本尊居然丝毫不惧！” 堂堂鲛人族殿下竟被人类幼崽当成小甜点，填鸭式圈养在身边。 怂萌女流氓陆昭昭眼见浴缸里泡着的银发半裸美男竟甩出了条硕大的鱼尾顿时吓晕。 咦，这突然发烫的脸皮是怎么回事？为什么只是偷偷舔了舔他的唇就莫名心跳加速？糟糕！我好像是消化不良了……'
  },
  {
    id:'5',
    name: '抢个道爷当娘子（2019版）',
    desc: ['纯爱', '古风'],
    author: '闻源文化',
    url: 'https://tn1-f2.kkmh.com/image/211014/MjFt4UnCk.webp-t.w207.webp.h',
    pcLink:'https://www.kuaikanmanhua.com/web/topic/9991/',
    mobileLink:'https://m.dm5.com/manhua-qianggedaoyedangniangzi/',
    instr: '被封印十世的魔尊一朝醒来，没了大半法力只能暂时骂骂咧咧的化形为的翩翩公子，路遇男扮女装的道士被人浸猪笼？！这货长得竟然和当年跟我作对的家伙一模一样！先救下来慢慢折磨他……'
  },
  {
    id:'6',
    name: '我的银河系恋爱史',
    desc: ['逆袭', '奇幻'],
    author: '闻源文化',
    url: 'https://tn1-f2.kkmh.com/image/190213/Gs86fDxrW.webp-t.w207.webp.h',
    pcLink:'https://www.kuaikanmanhua.com/web/topic/2524/',
    mobileLink:'https://m.dm5.com/manhua-wodeyinhexilianaishi/',
    instr: '没房没车没女友的三无漫画家，努力学习谈恋爱的银河系公主殿下，温柔腹黑愁嫁的虫巢御姐首领，自此李羡渔啼笑皆非的逆转人生开始了。当然，最大的难题是，如何搞定霸道多金魅力值永登榜首的岳父大人？'
  },
  {
    id:'7',
    name: '书灵记',
    desc: ['搞笑', '玄幻'],
    author: '索以文化&闻源文化',
    url: 'https://tn1-f2.kkmh.com/image/191021/96silBguX.webp-t.w207.webp.h',
    pcLink:'https://www.kuaikanmanhua.com/web/topic/3466/',
    mobileLink:'https://m.dm5.com/manhua-shulingji/',
    instr: '瀛洲界内，诸子百家，唐诗宋词，皆有书灵~ 三万年后，顾七绝从《唐诗三百首》中醒来，骑着《山海经》，决定去找《聊斋》小姐姐，谈谈如何征（zheng）服（jiu）世界—— “嗯，各位大佬好，我叫顾七绝，我情商低，我脑子有坑，还喜欢瞎说扎心大实话…… 但是没事，我长得好看，而且你们打不过我啊！”'
  },
]
export default list